import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import './assets'
import './global'
import './my-components'
import 'primeicons/primeicons.css'

Vue.config.productionTip = false

if (process.env.VUE_APP_SENTRY) {
  Sentry.init({
    Vue,
    dsn: 'https://9179cc673e4d4a2fa2d88dd4070786f5@o1276910.ingest.sentry.io/6474152',
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['dev-board.altezza.travel', 'board.altezza.travel', /^\//],
      }),
    ],
    tracesSampleRate: 1.0,
    environment: process.env.VUE_APP_SENTRY,
  })
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
